import { Container } from './RoBadge.styles';
import { Props } from './RoBadge.types';
import React from 'react';

const RoBadge = (props: Props) => {
  const { children, direction, badgeContent, max, bg, invert, asActive } = props;
  return badgeContent ? (
    <Container direction={direction} badgeContent={badgeContent} max={max} invert={invert} asActive={asActive} bg={bg}>
      {children}
    </Container>
  ) : (
    children
  );
};
export default RoBadge;
